import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { FormattedIntlCurrency } from 'I18n/components/FormattedIntlCurrency';
import FormattedMessage from 'I18n/components/FormattedMessage';

// @ts-expect-error untyped import
import UIAvatar from 'ui-addon-avatars/UIAvatar';
import { FormattedPeriod } from '../../components/overviewTable/FormattedPeriod';
import { CURRENCY_PRECISION } from '../../constants/Currency';
import { EMPTY_FIELD_VALUE } from '../../constants/OverviewTableConstants';
import { isMissingCurrencyCode } from '../../utils/currency';
import { DealSidebarAttainmentBar } from '../attainmentBars/DealSidebarAttainmentBar';
import { DealSidebarOverviewPipelineHelpText } from './DealSidebarOverviewPipelineHelpText';
import { TeamIcon } from '../TeamIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const DealSidebarOverview = ({
  assigneeType,
  closedWon,
  fiscalOffset,
  forecastAmount,
  goal,
  hasAllPipelinesGoal,
  isTeam,
  isUngatedToForecastingMultipleOutcomes,
  pipelines,
  timePeriod,
  userOrTeamData
}) => /*#__PURE__*/_jsxs(View, {
  marginBlockStart: isUngatedToForecastingMultipleOutcomes ? '500' : '200',
  children: [/*#__PURE__*/_jsx(Flex, {
    marginBlockEnd: "200",
    children: isTeam ? /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      children: [/*#__PURE__*/_jsx(View, {
        marginInlineEnd: "200",
        as: "span",
        children: /*#__PURE__*/_jsx(TeamIcon, {})
      }), userOrTeamData.name]
    }) : /*#__PURE__*/_jsx(UIAvatar, {
      hubSpotUserEmail: userOrTeamData.email,
      truncateLength: 400,
      children: /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        children: [userOrTeamData.name, !userOrTeamData.isActive && /*#__PURE__*/_jsx(Text, {
          as: "small",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "dealSidebar.deactivatedUserLabel"
          })
        })]
      })
    })
  }), /*#__PURE__*/_jsxs(Flex, {
    children: [/*#__PURE__*/_jsx("b", {
      children: /*#__PURE__*/_jsx(FormattedPeriod, {
        timePeriod: timePeriod,
        offset: fiscalOffset
      })
    }), /*#__PURE__*/_jsx(DealSidebarOverviewPipelineHelpText, {
      pipelines: pipelines,
      assigneeType: assigneeType,
      isTeam: isTeam,
      hasGoal: !!goal.value,
      hasAllPipelinesGoal: hasAllPipelinesGoal
    })]
  }), /*#__PURE__*/_jsx(View, {
    marginBlockStart: "300",
    as: "div",
    children: /*#__PURE__*/_jsx(DealSidebarAttainmentBar, {
      value: closedWon,
      goal: goal
    })
  }), /*#__PURE__*/_jsxs(Flex, {
    justifyContent: "space-between",
    children: [/*#__PURE__*/_jsxs(Flex, {
      justifyContent: "space-between",
      flexDirection: "column",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "dealSidebar.closed"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "dealSidebar.goal"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "dealSidebar.forecasted"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "dealSidebar.gapToGoal"
      })]
    }), /*#__PURE__*/_jsxs(Flex, {
      justifyContent: "space-between",
      flexDirection: "column",
      alignItems: "end",
      children: [/*#__PURE__*/_jsx("div", {
        "data-test-id": "deal-sidebar-closed",
        children: /*#__PURE__*/_jsx(FormattedIntlCurrency, {
          value: closedWon.value,
          precision: CURRENCY_PRECISION,
          currencyCode: closedWon.currencyCode
        })
      }), /*#__PURE__*/_jsx("div", {
        "data-test-id": "deal-sidebar-goal",
        children: goal && !isMissingCurrencyCode(goal) ? /*#__PURE__*/_jsx(FormattedIntlCurrency, {
          value: goal.value,
          precision: CURRENCY_PRECISION,
          currencyCode: goal.currencyCode
        }) : EMPTY_FIELD_VALUE
      }), /*#__PURE__*/_jsx("div", {
        "data-test-id": "deal-sidebar-forecasted",
        children: !isMissingCurrencyCode(forecastAmount) ? /*#__PURE__*/_jsx(FormattedIntlCurrency, {
          currencyCode: forecastAmount.currencyCode,
          precision: CURRENCY_PRECISION,
          value: forecastAmount.value
        }) : EMPTY_FIELD_VALUE
      }), /*#__PURE__*/_jsx("div", {
        "data-test-id": "deal-sidebar-gap-to-goal",
        children:
        // if the goal and closed won have different currency codes, gap value
        // is not accurate and should not be displayed
        goal && closedWon && closedWon.currencyCode === goal.currencyCode ? /*#__PURE__*/_jsx(FormattedIntlCurrency, {
          value: goal.value - closedWon.value > 0 ? goal.value - closedWon.value : 0,
          precision: CURRENCY_PRECISION,
          currencyCode: goal.currencyCode
        }) : EMPTY_FIELD_VALUE
      })]
    })]
  })]
});